import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Delivery from '../../Delivery';
import { MapPinIcon } from '@heroicons/react/24/solid';

const Address = () => {
	const user = useSelector((store) => store?.user);
	const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(false);
  const focusRef = useRef(null);

	const handleOpen = () => {
		setIsOpenBottomSheet(true);
	};

	const handleClose = () => {
		setIsOpenBottomSheet(false);
	};

	const deliveryProps = useMemo(() => {
		return {
			onClose: handleClose,
		};
	}, []);

	return (
		<>
			<div id='homepage_delivery_to' className='flex flex-1 min-w-0 items-center gap-1 rounded-full bg-gray-700/70 h-8 px-2' onClick={handleOpen}>
				<MapPinIcon className='min-h-5 h-5 min-w-5 w-5 text-white' />
				<div className='flex-1 truncate text-xs text-white'>{user?.addressName || user?.address}</div>
				<ChevronDownIcon className='h-4 w-4 shrink-0 text-white' strokeWidth={2} />
			</div>
			<BottomSheet
				key={'delivery-location'}
        initialFocusRef={focusRef}
				open={isOpenBottomSheet}
				onDismiss={handleClose}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}>
				<Delivery {...deliveryProps} />
			</BottomSheet>
		</>
	);
};

export default Address;
